import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface QuickStatsFilter {
  tab: string | null; // 'todayOrders' | 'deliveries' | 'pickup'
  orderDate: string | null;
  orderType: string | null;
  searchtext:string|null;
}

@Injectable({
  providedIn: 'root'
})
export class QuickStatsFilterService {
  
  private quickStatsFilterSubject: BehaviorSubject<QuickStatsFilter>;
  public quickStatsFilter$: Observable<QuickStatsFilter>;

  constructor() {
    // 🔹 Initialize from storage for zero-delay sync
    const savedSearch = localStorage.getItem('orderHeaderSearch') || null;
    
    // Attempt to restore other filters if they exist in standard format
    let savedFilters: any = {};
    try {
      const filtersRaw = localStorage.getItem('orderListFilters');
      if (filtersRaw) savedFilters = JSON.parse(filtersRaw);
    } catch (e) {}

    this.quickStatsFilterSubject = new BehaviorSubject<QuickStatsFilter>({
      tab: savedFilters.tab || null,
      orderDate: savedFilters.orderDate || null,
      orderType: savedFilters.orderType || null,
      searchtext: savedSearch || savedFilters.searchText || null,
    });

    this.quickStatsFilter$ = this.quickStatsFilterSubject.asObservable();
  }

  /**
   * Update quick stats filter
   */
  updateQuickStatsFilter(tab: string | null =null, orderDate: string | null = null, orderType: string | null = null,searchtext:string|null=null) {
    this.quickStatsFilterSubject.next({
      tab,
      orderDate,
      orderType,
      searchtext,
    });
  }

  /**
   * Get current filter snapshot
   */
  getFilterSnapshot(): QuickStatsFilter {
    return this.quickStatsFilterSubject.value;
  }
}
